import {useEffect, useState} from "@wordpress/element";
import spinner from "@wordpress/components/src/spinner/index";
import CashierAccount from "./CashierAccount";
import {useSelect} from "@wordpress/data";

const { __ } = window.wp.i18n;
const { registerPlugin } = window.wp.plugins;
const { ExperimentalOrderMeta, Panel, Label } = window.wc.blocksCheckout;
const { cartStore } = window.wc.wcBlocksData;

const render = () => {

	// Early return where aren't on the checkout page.
	if ( ! document.body.classList.contains( 'woocommerce-checkout' ) ) {
		return null;
	}

	// Re-render on each update of coupons.
	const coupons = useSelect(
		(select) => select(cartStore).getCartData().coupons,
		[]
	);

	// Re-render on each update of cart totals.
	const cart_totals = useSelect(
		(select) => select(cartStore).getCartData().totals,
		[]
	);

	// State for loading cashier payment blocks.
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [accounts, setAccounts] = useState( null );
	const [hidden, setHidden] = useState( false );

	// Get cashier account details via REST.
	useEffect(() => {

		setLoading(true);

		const getAccounts = async () => {

			try{

				// Grab accounts via REST.
				const res = await fetch( '/wp-json/wc/zap/v1/user-cashier-accounts', {
					method: 'GET',
					credentials: 'include',
					headers: {
						'X-WP-Nonce': ZapCashierCheckout.nonce
					}
				} )

				if(!res.ok) throw new Error("Network response was not ok");

				const data = await res.json();
				setAccounts(data.accounts);

			} catch(error){
				setError(error.message);
			} finally {
				setLoading(false);
			}
		}

		getAccounts();

	}, []);


	// Only show if no cashier coupons are currently applied.
	const has_cashier_coupon = coupons && coupons.find( coupon => coupon.code.startsWith('zap_cashier_') );

	// Only show where we have a > 0.00 order.
	const non_zero_order = parseInt( cart_totals.total_price ) > 0;

	return (
		<ExperimentalOrderMeta>

			<div className="zap-cashier-checkout-block">

				{ !loading && ! error && accounts && ! has_cashier_coupon && non_zero_order && (
					accounts.map( (account, i) => ( <CashierAccount account={account} key={i} /> ))
				) }

				{ loading && ( <i className="fa fa-spinner fa-spin"></i> ) }

			</div>

		</ExperimentalOrderMeta>
	);
};

// Check block isn't aleady registered, then register.
if ( ! window.zapCashierRegistered ) {
	window.wp.plugins.registerPlugin( 'zap-competitions-cashier-checkout', {
		render,
		scope: 'woocommerce-checkout',
	} );
	window.zapCashierRegistered = true;
}